import React from 'react';
import { AccentBar, EmptySection, Section, SectionHeader, SectionTitle } from './blocks';

const TariffSection = ({ label, empty, children }) => (
    <Section aria-label={label}>
        <SectionHeader>
            <AccentBar />
            <SectionTitle>{label}</SectionTitle>
        </SectionHeader>
        {empty ? <EmptySection>None yet.</EmptySection> : children}
    </Section>
);

export default TariffSection;
